export function useStickySearch(searchBarId: string, fixedEl: string, offset = 0) {
  const isFixed = ref(false)
  const placeholderHeight = ref(0)
  let searchBarLoc: HTMLElement | null = null
  let searchBar: HTMLElement | null = null
  let placeholder: HTMLElement | null = null

  const getElementHeightWithMargin = (element: HTMLElement) => {
    const styles = window.getComputedStyle(element)
    const marginTop = parseFloat(styles.marginTop) || 0
    const marginBottom = parseFloat(styles.marginBottom) || 0
    return element.offsetHeight + marginTop + marginBottom
  }

  const updateSticky = () => {
    if (!searchBarLoc) {
      window.removeEventListener('scroll', updateSticky)
      if (searchBar) {
        searchBar.style.position = ''
        searchBar.style.top = ''
        searchBar.style.zIndex = ''
        placeholder?.remove()
        placeholder = null
        isFixed.value = false
      }
      return
    }
    if (searchBarLoc.offsetParent === null) {
      searchBarLoc = document.querySelector(searchBarId)
      searchBar = document.querySelector(fixedEl)
    }
    if (searchBarLoc?.offsetParent?.className?.includes('hdr-m__fixed-ac') || searchBarLoc?.offsetParent?.className?.includes('hdr-m__fixed-nac') || searchBarLoc?.offsetParent?.className?.includes('hdr-p__fixed-ac') || searchBarLoc?.offsetParent?.className?.includes('hdr-p__fixed-nac')) {
      setTimeout(() => updateSticky(), 1)
      return
    }
    const rect = searchBarLoc?.getBoundingClientRect()
    if (!rect) {
      window.removeEventListener('scroll', updateSticky)
      return
    }
    const offsetTop = rect.top + window.scrollY

    if (window.scrollY >= offsetTop - offset) {
      if (!isFixed.value) {
        searchBar.style.position = 'fixed'
        searchBar.style.top = `${offset}px`
        searchBar.style.zIndex = '20'
        placeholderHeight.value = getElementHeightWithMargin(searchBar)

        if (!placeholder) {
          placeholder = document.createElement('div')
          placeholder.style.height = `${placeholderHeight.value}px`
          searchBar.parentNode?.insertBefore(placeholder, searchBar)
        }

        isFixed.value = true
      }
    }
    else {
      if (isFixed.value) {
        searchBar.style.position = ''
        searchBar.style.top = ''
        searchBar.style.zIndex = ''
        placeholder?.remove()
        placeholder = null
        isFixed.value = false
      }
    }
  }

  const getElements = () => {
    searchBarLoc = document.querySelector(searchBarId)
    searchBar = document.querySelector(fixedEl)
  }

  onMounted(() => {
    getElements()
    if (searchBarLoc) {
      updateSticky()
      window.addEventListener('scroll', updateSticky)
    }
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', updateSticky)
  })

  return { isFixed, placeholderHeight, getElements }
}
